import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { ErrorResponse } from '@core/models';
import { inject } from '@angular/core';
import { PornRepository } from '@core/repositories/porn.repository';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { debounceTime, distinctUntilChanged, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { PornActress } from '@api/backend';

type StarsState = {
  list: PornActress[];
  isLoading: boolean;
  error: ErrorResponse | null;
  totalPages: number,
  actor: PornActress | null
};

export const initialStarsState: StarsState = {
  list: [],
  isLoading: false,
  error: null,
  totalPages: 0,
  actor: null,
};

export const StarsStore = signalStore(
  withState(initialStarsState),
  withMethods((
    state,
    api = inject(PornRepository),
  ) => ({
    loadByQuery: rxMethod<{
      piercing?: boolean, tattoo?: boolean, silicone?: boolean, assSize?: string, waistSize?: string,
      breastSize?: string, height?: string, weight?: string, age?: string, q?: string, r?: string, p?: number,
      pageSize?: number
    }>(
      pipe(
        debounceTime(10),
        distinctUntilChanged(),
        tap(() => patchState(state, { isLoading: true })),
        switchMap((params) => {
          return api.getStars(params).pipe(
            tapResponse({
              next: (response) => {
                patchState(state, { list: response.data.actresses, totalPages: response.data.total_pages });
              },
              error: () => {},
              finalize: () => patchState(state, { isLoading: false }),
            }),
          );
        }),
      ),
    ),
    loadById: rxMethod<{ id: string }>(
      pipe(
        debounceTime(10),
        distinctUntilChanged(),
        tap(() => patchState(state, { isLoading: true })),
        switchMap(({ id }) => {
          return api.getStarById(id).pipe(
            tapResponse({
              next: (response) => {
                patchState(state, { actor: response.data });
              },
              error: () => {},
              finalize: () => patchState(state, { isLoading: false }),
            }),
          );
        }),
      ),
    ),
  })),
  withHooks((store) => ({
    onInit() {
      store.loadByQuery({});
    },
  })),
);